// Build-time configuration. Injected by scripts/deploy.sh from the deployed stacks'
// CloudFormation outputs -- there is no committed config file and no .env in the repo
// (see the plan's "no .env anywhere" rule). The API URL is public information; it is
// config, not a secret.
const API_URL = import.meta.env.VITE_API_URL;

if (!API_URL) {
    throw new Error(
        'VITE_API_URL was not set at build time. Build via scripts/deploy.sh, or export it ' +
        'from the V2-Api stack output ApiUrl before running `npm run build`.',
    );
}

export const config = {
    apiUrl: API_URL.replace(/\/$/, ''),
};
